<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('invoiceConfirm.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('invoiceConfirm.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="row">
            <div class="form-group ts-h-full col-md-8">
              <form class="ts-h-full">
                <fieldset class="ts-h-full">
                  <legend>{{ $t('invoiceConfirm.createFrom') }}</legend>
                  <invoice-list @selected="onPickInvoice" />
                </fieldset>
              </form>
            </div>
            <div class="col-md-4 mt-3">
              <div class="ts-flex ts-space-x-5 ts-border ts-border-blue-300 ts-rounded-md ts-p-4">
                <div class="ts-w-56 ts-h-48 ts-rounded-sm ts-overflow-hidden">
                  <img :src="student.photo ? student.photo : default_imag" alt="" @error="setAltImg"
                    class="ts-object-fill" />
                </div>
                <div class="ts-w-full ts-space-y-3">
                  <div class="ts-flex ts-justify-between ts-border-b ts-border-gray-300">
                    <strong>{{ $t('invoiceConfirm.studentName') }} : </strong>
                    <p>{{ student.full_name_en }}</p>
                  </div>
                  <div class="ts-flex ts-justify-between ts-border-b ts-border-gray-300">
                    <strong>{{ $t('invoiceConfirm.cardNumber') }} : </strong>
                    <p>{{ student.card_number }}</p>
                  </div>
                  <div class="ts-flex ts-justify-between ts-border-b ts-border-gray-300">
                    <strong>{{ $t('invoiceConfirm.sex') }} : </strong>
                    <p>{{ student.gender }}</p>
                  </div>
                  <div class="ts-flex ts-justify-between ts-border-b ts-border-gray-300">
                    <strong>{{ $t('invoiceConfirm.grade') }} : </strong>
                    <p>{{ invoices.grade_name_foreign }}</p>
                  </div>
                  <div class="ts-flex ts-justify-between ts-border-b ts-border-gray-300">
                    <strong>{{ $t('invoiceConfirm.className') }} : </strong>
                    <p>{{ invoices.class_name }}</p>
                  </div>
                  <div class="ts-flex ts-justify-between ts-border-b ts-border-gray-300">
                    <strong>{{ $t('invoiceConfirm.studyTime') }} : </strong>
                    <p>{{ invoices.study_time }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-show="histories.length > 0">
            <div class="form-group ts-h-full col-md-12">
              <form class="ts-h-full">
                <fieldset class="ts-h-full">
                  <legend>{{ $t('invoiceConfirm.history') }}</legend>
                  <table class="ts-h-full">
                    <thead>
                      <tr>
                        <th class="ts-uppercase ts-bg-gray-100 ts-py-2 ts-px-3 ts-w-2/12">
                          {{ $t('invoiceConfirm.barcode') }}
                        </th>
                        <th class="ts-uppercase ts-bg-gray-100 ts-py-2 ts-px-3" style="width: 27%;">
                          {{ $t('invoiceConfirm.productName') }}
                        </th>
                        <th class="ts-uppercase ts-bg-gray-100 ts-py-2 ts-px-3 ts-w-32 ts-text-center">
                          {{ $t('invoiceConfirm.uom') }}
                        </th>
                        <th class="ts-uppercase ts-bg-gray-100 ts-py-2 ts-px-3 ts-w-32 ts-text-center">
                          {{ $t('invoiceConfirm.packageQty') }}
                        </th>
                        <th class="ts-uppercase ts-bg-gray-100 ts-py-2 ts-px-3 ts-w-32 ts-text-center">
                          {{ $t('invoiceConfirm.receivedQty') }}
                        </th>
                        <th class="ts-uppercase ts-bg-gray-100 ts-py-2 ts-px-3 ts-w-32 ts-text-center">
                          {{ $t('invoiceConfirm.outstandingQty') }}
                        </th>
                        <th class="ts-uppercase ts-bg-gray-100 ts-py-2 ts-px-3" style="width: 24%;">
                          {{ $t('invoiceConfirm.remark') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(records, delivery_number) in histories">
                        <tr>
                          <td class="ts-py-1 ts-px-3 ts-font-semibold text-primary">Delivery Number: {{
                            records.mdo_number }}</td>
                        </tr>
                        <tr v-for="(item, index) in records.material_delivery_order_detail">
                          <td class=" ts-py-1 ts-px-3">{{ item.barcode }}</td>
                          <td class=" ts-py-1 ts-px-3">{{ item.product_name_en }}</td>
                          <td class=" ts-py-1 ts-text-center ts-px-3">{{ item.uom_name_en }}</td>
                          <td class=" ts-py-1 ts-text-center ts-px-3">{{ item.quantity_packaged }}</td>
                          <td class=" ts-py-1 ts-text-center ts-px-3">{{ item.quanity_delivered }}</td>
                          <td class=" ts-py-1 ts-text-center ts-px-3">{{ item.quanity_remain }}</td>
                          <td class=" ts-py-1 ts-px-3">{{ item.remark }}</td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </fieldset>
              </form>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-12 form-group ts-h-full">
              <table class="ts-w-full">
                <thead>
                  <tr>
                    <th class="ts-uppercase ts-bg-gray-300 ts-py-2 ts-px-3 ts-w-2 ts-pb-4">
                      <ts-checkbox :checkedValue="isAllCheck" @change="allCheckChange">{{ $t('invoiceConfirm.all')
                      }}</ts-checkbox>
                    </th>
                    <th class="ts-uppercase ts-bg-gray-300 ts-py-2 ts-px-3">
                      <span class="required">{{ $t('invoiceConfirm.barcode') }}</span>
                    </th>
                    <th class="ts-uppercase ts-bg-gray-300 ts-py-2 ts-px-3">
                      <span class="required">{{ $t('invoiceConfirm.productName') }}</span>
                    </th>
                    <th class="ts-uppercase ts-bg-gray-300 ts-py-2 ts-px-3 ts-w-32 ts-text-center required">
                      {{ $t('invoiceConfirm.uom') }}
                    </th>
                    <th class="ts-uppercase ts-bg-gray-300 ts-py-2 ts-px-3 ts-w-32 ts-text-center">
                      {{ $t('invoiceConfirm.packageQty') }}
                    </th>
                    <th class="ts-uppercase ts-bg-gray-300 ts-py-2 ts-px-3 ts-w-32 ts-text-center required">
                      {{ $t('invoiceConfirm.receivedQty') }}
                    </th>
                    <th class="ts-uppercase ts-bg-gray-300 ts-py-2 ts-px-3 ts-w-32 ts-text-center">
                      {{ $t('invoiceConfirm.outstandingQty') }}
                    </th>
                    <th class="ts-uppercase ts-bg-gray-300 ts-py-2 ts-px-3">
                      {{ $t('invoiceConfirm.remark') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="ts-border-b ts-border-gray-300" v-for="(p, index) in model.product_list" :key="index">
                    <td class=" ts-py-2 ts-px-3">
                      <div class="checkbox checkbox-css">
                        <input type="checkbox" v-model="p.is_check" :id="index" />
                        <label :for="index"></label>
                      </div>
                    </td>
                    <td>
                      <a-select v-model="p.product_id" class="ts-w-full" disabled showSearch :options="productOption('barcode')"
                        :filterOption="filterOption" @change="val => productChange(val, p)" />
                    </td>
                    <td>
                      <a-select v-model="p.product_id" class="ts-w-full" disabled
                        :options="productOption('product_name_en')" :filterOption="filterOption"
                        @change="val => productChange(val, p)" />
                      <div class="validate" v-if="errors.has('details.' + index + '.product_id')">
                        {{ errors.first('details.' + index + '.product_id') }}
                      </div>
                    </td>
                    <td class=" ts-py-1 ts-text-center ts-px-3">
                      <a-select v-model="p.uom_id" class="ts-w-48" showSearch disabled :options="uomOption(p)"
                        :filterOption="filterOption" />
                    </td>
                    <td class=" ts-py-1 ts-text-center ts-px-3">
                      {{ p.original_qty }}
                    </td>
                    <td class=" ts-py-1 ts-text-center ts-px-3">
                      <input type="number" min="0" v-model.number="p.deliver_qty"
                        class="ts-border ts-px-3 ts-py-1 ts-rounded-md ts-outline-none ts-w-16"
                        @change="e => qtyInputValidate(e, p.original_qty, p)" />
                    </td>
                    <td class=" ts-py-1 ts-text-center ts-px-3">
                      {{ p.original_qty - p.deliver_qty }}
                    </td>
                    <td>
                      <textarea v-model="p.remark" rows="1" class="form-control"></textarea>
                    </td>
                  </tr>
                </tbody>
              </table>
              <textarea v-model="model.comment" placeholder="Comments..." class="form-control ts-mt-3"
                rows="3"></textarea>
              <div class="ts-space-x-3 ts-text-right">
                <ts-button @click="$router.push('/invoice-confirm')" class="ts-mt-3">{{ $t('cancel') }}
                </ts-button>
                <ts-button color="primary" @click="onStore" class="ts-mt-3">{{ $t('save') }}
                </ts-button>
              </div>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import { cloneDeep, isEmpty, includes, parseInt } from 'lodash'
import InvoiceList from './component/invoice_list'

export default {
  name: 'invoiceScan',
  components: {
    InvoiceList
  },
  data() {
    return {
      loading: false,
      visible: false,
      invoice_number: null,
      default_imag: require('@/assets/student_default.png'),
      student: {
        photo: undefined,
        full_name_en: undefined,
        card_number: undefined,
        gender: undefined
      },
      invoices: {
        grade_name_foreign: undefined,
        class_name: undefined,
        study_time: undefined
      },
      model: {
        inv_id: null,
        student_id: null,
        ac_year_id: null,
        ac_term_id: null,
        class_id: null,
        ref_inv_number: null,
        remark: null,
        comment: null,
        location_id: null,
        product_list: []
      },
      errors: new Errors(),
      histories: [],
      products: [],
      uoms: [],
    }
  },
  computed: {
    isAllCheck() {
      if (this.model.product_list.length > 0) {
        return (
          this.model.product_list.length ==
          this.model.product_list.filter(e => e.is_check == true).length
        )
      }
      return false
    },
    productOption: vm => key => {
      return vm.products.map(el => ({
        value: el.product_id,
        label: el[key]
      }))
    },
    uomOption: vm => product => {
      const uomCatId = parseInt(product.uom_cat_id)
      return vm.uoms.filter(f => f.uom_cat_id == uomCatId).map(el => ({
        value: el.uom_id,
        label: el.uom_name_en
      }));
    }
  },
  created() {
    this.fetchProduct();
  },
  methods: {
    ...mapActions('invoiceConfirm', ['scanInvoice', 'store', 'getProduct', 'formViewModel']),
    filterProductFunction(search, options) {
      return options.filter(option => {
        option = typeof option === 'object' ? option.text : option

        return option.toLowerCase().includes(search.toLowerCase())
      })
    },
    async onPickInvoice(invoice) {
      this.student.full_name_en = invoice.first_name_en + ' ' + invoice.last_name_en
      this.student.card_number = invoice.card_number
      this.student.gender = invoice.gender
      this.student.photo = invoice.photo
      this.invoices.grade_name_foreign = invoice.grade_name_foreign
      this.invoices.class_name = invoice.class_name
      this.invoices.study_time = invoice.study_time
      this.scanInvoiceProduct(invoice)
      this.fetchHistory(invoice)
    },
    fetchProduct() {
      this.products = []
      this.loading = true
      this.formViewModel({
        fnName: "product,uom"
      })
        .then(response => {
          this.products = response.product;
          this.uoms = response.uom;
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchHistory(invoice) {
      this.formViewModel({
        fnName: 'historyMaterialDelivery',
        inv_id: invoice.inv_id
      })
        .then(response => {
          this.histories = response.historyMaterialDelivery
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    scanInvoiceProduct(invoice) {
      this.loading = true
      this.scanInvoice({
        invoice_id: invoice.inv_id
      })
        .then(response => {
          if (!isEmpty(response.data)) {
            let { student, ...invoice } = response.data
            this.student = student
            this.invoices = invoice
            this.model.inv_id = invoice.inv_id
            this.model.student_id = invoice.student_id
            this.model.ac_year_id = invoice.ac_year_id
            this.model.ac_term_id = invoice.ac_term_id
            this.model.class_id = invoice.class_id
            this.model.ref_inv_number = invoice.inv_number
            this.model.product_list = []

            const mdoProductId = invoice.mdo_main.filter(el => el.quanity_remain == 0).map(el => parseInt(el.product_id));

            invoice.stock_out_from_invoice.filter(el => !includes(mdoProductId, parseInt(el.product_id))).forEach(element => {
              const mdoItem = invoice.mdo_main.filter(mdo => parseInt(mdo.product_id) === element.product_id).pop();
              this.model.product_list.push(
                Object.assign({}, element, {
                  is_check: true,
                  remark: this.model.remark,
                  original_qty: mdoItem ? mdoItem.quanity_remain : element.quantity,
                  deliver_qty: mdoItem ? mdoItem.quanity_remain : element.quantity
                })
              )
            })
            this.model.location_id = this.model.product_list.length > 0 ? this.model.product_list[0]['location_id'] : null
          }
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    setAltImg(event) {
      event.target.src = this.default_imag
    },
    allCheckChange(e) {
      if (e) {
        this.model.product_list.forEach(el => (el.is_check = true))
      } else {
        this.model.product_list.forEach(el => (el.is_check = false))
      }
    },
    qtyInputValidate(e, originQty, row) {
      var value = e.target.value
      if (!value || value > originQty || value < 0) {
        row.quantity = originQty
      }
    },
    onStore() {
      this.loading = true
      this.errors = new Errors()
      var newModel = cloneDeep(this.model)
      newModel.product_list = this.model.product_list.filter(el => el.is_check)
      this.store(newModel)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'invoice-confirm' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput() {
      this.student.photo = undefined
      this.student.full_name_en = undefined
      this.student.card_number = undefined
      this.student.gender = undefined

      this.invoices.grade_name_foreign = undefined
        ; (this.invoices.class_name = undefined),
          (this.invoices.study_time = undefined)

      this.model.inv_id = null
      this.model.student_id = null
      this.model.ac_year_id = null
      this.model.ac_term_id = null
      this.model.class_id = null
      this.model.ref_inv_number = null
      this.model.comment = null
      this.model.product_list = []
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    },
    productChange(productId, row) {
      const product = this.products.find(p => p.product_id == productId)
      if (!product) {
        row.uom_id = undefined
        return;
      }
      const uomCatId = product.uom_cat_id
      const defaultUom = this.uoms.find(f => f.uom_cat_id == uomCatId && f.is_default)

      if (defaultUom) {
        row.uom_cat_id = defaultUom.uom_cat_id
        row.uom_id = defaultUom.uom_id
      } else {
        row.uom_id = undefined
      }
    }
  }
}
</script>
